import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCk92jrfArC4e7295U5Rr0R4kAhYRm7tFc",
  authDomain: "betintel-90f91.firebaseapp.com",
  projectId: "betintel-90f91",
  storageBucket: "betintel-90f91.firebasestorage.app",
  messagingSenderId: "1069406770842",
  appId: "1:1069406770842:web:37e5c60f3dbc8df676f123"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;